import {
    type TCollectionSuggestions as TApiCollectionSuggestions,
    getCollectionSuggestionsUrl,
} from '@core/api'
import { httpClient } from '@core/http-client'

import { convertCollectionSuggestions } from '@core/converters'

type TGetCollectionSuggestionsParams = {
    username: string
    slug: string
    signal?: AbortSignal
}

export const getCollectionSuggestions = async ({
    username,
    slug,
    signal,
}: TGetCollectionSuggestionsParams) => {
    const apiSuggestions = await httpClient
        .get(getCollectionSuggestionsUrl(username, slug), { signal })
        .json<TApiCollectionSuggestions>()

    return convertCollectionSuggestions(apiSuggestions)
}
